// extracted by mini-css-extract-plugin
export default {"SidebarSlider":"style_SidebarSlider__cgBR3"};